module.exports = __webpack_public_path__ + "img/lightsnow.dec108a9.png";